import jwtEncode from 'jwt-encode';

const JWT_SECRET_KEY: any = process.env.REACT_APP_JWT_SECRET_KEY;

export const encodeJwt = async (otp: any) => {
    const payload: any = { otp };
    const token = jwtEncode(payload, JWT_SECRET_KEY, { expiresIn: '1h' });
    return token;
};